import config from "./configuration";
import ConstantsList from "../common/SupplierConstants";

// this block needed to get the login Token and Login user _id
let localData = localStorage.getItem("userData");
let userData = {};
if (localData) {
  userData = JSON.parse(localData);
}

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

/* Service Function starts here */

//POST - getMenuOnUserRole
async function getMenuOnUserRole(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getMenu";
  return callPOST(api_url, param);
}

// get info from the configuration.js file
async function getConfig() {
  return config;
}

//POST - Get User Login Details using _id
async function getLoginUserData() {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/getUserDetails";
  let param = { _id: userData.data._id };
  return callPOST(api_url, param);
}

// API Error Handling
async function handleResponseError(response) {
  throw new Error("HTTP error, status = " + response.status);
}

// API Error Handling
async function handleError(error) {
  console.log(error.message);
}

// Common GET Method
async function callGET(api_url) {
  return fetch(api_url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + userData.token,
    },
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
      }
      return response.json();
    })
    .then((items) => {
      if (items.responseCode !== 401) {
        // console.log(">> GET Service Call",items);
        return items;
      } else {
        console.log(">> Session Timeout", items);
        localStorage.setItem("token", "");
        localStorage.setItem("userData", "");
        window.location = ConstantsList.LOGIN;
      }
    })
    .catch((error) => {
      console.log(">> e", error);
      handleError(error);
    });
}

// Common POST Method
async function callPOST(api_url, param) {
  // console.log(">> check URL", api_url);
  if (!param) {
    param = {};
  }
  param.timeZone = userTimezone;
  return await fetch(api_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + userData.token,
    },
    body: JSON.stringify(param),
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
      }
      return response.json();
    })
    .then((items) => {
      // console.log(">> Service Login Data",items);
      if (items.responseCode !== 401) {
        // console.log(">> POST Service Call",items);
        return items;
      } else {
        console.log(">> Session Timeout", items);
        localStorage.setItem("token", "");
        localStorage.setItem("userData", "");
        window.location = ConstantsList.LOGIN;
      }
    })
    .catch((error) => {
      handleError(error);
    });
}

// Common POST Method for Upload
async function callPOSTUpload(api_url, param) {
  // console.log(">>callPOSTUpload param ", param);
  return await fetch(api_url, {
    method: "POST",
    headers: {
      // 'Content-Type': 'multipart/form-data',
      Authorization: "Bearer " + userData.token,
    },
    body: param,
  })
    .then((response) => {
      if (!response.ok) {
        handleResponseError(response);
      }
      return response.json();
    })
    .then((items) => {
      // console.log(">> Service Login Data",items);
      if (items.responseCode !== 401) {
        // console.log(">> POST Service Call",items);
        return items;
      } else {
        console.log(">> Session Timeout", items);
        localStorage.setItem("token", "");
        localStorage.setItem("userData", "");
        window.location = ConstantsList.LOGIN;
      }
    })
    .catch((error) => {
      handleError(error);
    });
}

//POST - Upload files
async function uploadFiles(param) {
  let api_url = config.BASE_URL + "api/uploadFiles";
  return callPOSTUpload(api_url, param);
}
//POST - getUploadedFiles files
async function getUploadedFiles(param) {
  let api_url = config.BASE_URL + "api/getUploadedFiles";
  return callPOST(api_url, param);
}

/* ---------------------------- Dashboard --------------------------------*/

//dashboard - supplier // "Yearly", "Monthly", "Custom"
async function dashboard(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/dashboard";
  return callPOST(api_url, param);
}

//Generate Chart Query
async function generateChartQuery(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "api/generateChartQuery";
  return callPOST(api_url, param);
}

async function addEmployee(param) {
  let api_url = config.BASE_URL + "hr/api/addEmployee";
  return callPOST(api_url, param);
}
async function cancelOrDeleteEmp(param) {
  let api_url = config.BASE_URL + "hr/api/cancelOrDeleteEmp";
  return callPOST(api_url, param);
}
async function updateEmployee(param) {
  let api_url = config.BASE_URL + "hr/api/updateEmployee";
  return callPOST(api_url, param);
}
async function markAttendance(param) {
  let api_url = config.BASE_URL + "hr/api/markAttendance";
  return callPOST(api_url, param);
}
async function getAttendance(param) {
  let api_url = config.BASE_URL + "hr/api/getAttendance";
  return callPOST(api_url, param);
}
async function getAllAttendance(param) {
  let api_url = config.BASE_URL + "hr/api/getAllAttendance";
  return callPOST(api_url, param);
}
async function updateAttendance(param) {
  let api_url = config.BASE_URL + "hr/api/updateAttendance";
  return callPOST(api_url, param);
}
async function addHrDocuments(param) {
  let api_url = config.BASE_URL + "hr/api/addHrDocuments";
  return callPOST(api_url, param);
}
async function cancelOrDeleteHrDoc(param) {
  let api_url = config.BASE_URL + "hr/api/cancelOrDeleteHrDoc";
  return callPOST(api_url, param);
}
async function updateHrDocuments(param) {
  let api_url = config.BASE_URL + "hr/api/updateHrDocuments";
  return callPOST(api_url, param);
}
async function approveHrDocument(param) {
  let api_url = config.BASE_URL + "hr/api/approveHrDocument";
  return callPOST(api_url, param);
}
async function addTask(param) {
  let api_url = config.BASE_URL + "hr/api/addTask";
  return callPOST(api_url, param);
}
async function generateCustomerQuery(param) {
  // This method calling from Redux
  let api_url = config.BASE_URL + "customer/api/generateCustomerQuery";
  return callPOST(api_url, param);
}
async function updateTask(param) {
  let api_url = config.BASE_URL + "hr/api/updateTask";
  return callPOST(api_url, param);
}
async function cancelOrDeleteTask(param) {
  let api_url = config.BASE_URL + "hr/api/cancelOrDeleteTask";
  return callPOST(api_url, param);
}
async function getAllTask(param) {
  let api_url = config.BASE_URL + "hr/api/getAllTask";
  return callPOST(api_url, param);
}
async function getTask(param) {
  let api_url = config.BASE_URL + "hr/api/getTask";
  return callPOST(api_url, param);
}
async function updateTaskStatus(param) {
  let api_url = config.BASE_URL + "hr/api/updateTaskStatus";
  return callPOST(api_url, param);
}
async function getEmployeeOrg(param) {
  let api_url = config.BASE_URL + "hr/api/getEmployeeOrg";
  return callPOST(api_url, param);
}
async function uploadEmployeeImg(param) {
  let api_url = config.BASE_URL + "hr/api/uploadEmployeeImg";
  return callPOSTUpload(api_url, param);  // ✅ correct helper
}

async function addExpenses(param) {
  let api_url = config.BASE_URL + "hr/api/addExpenses";
  return callPOST(api_url, param);
}

async function cancelOrDeleteExpense(param) {
  let api_url = config.BASE_URL + "hr/api/cancelOrDeleteExpense";
  return callPOST(api_url, param);
}
async function updateExpense(param) {
  let api_url = config.BASE_URL + "hr/api/updateExpense";
  return callPOST(api_url, param);
}
async function addProject(param) {
  let api_url = config.BASE_URL + "hr/api/addProject";
  return callPOST(api_url, param);
}
async function cancelOrDeleteProject(param) {
  let api_url = config.BASE_URL + "hr/api/cancelOrDeleteProject";
  return callPOST(api_url, param);
}
async function updateProject(param) {
  let api_url = config.BASE_URL + "hr/api/updateProject";
  return callPOST(api_url, param);
}
async function getClientDrop(param) {
  let api_url = config.BASE_URL + "hr/api/getClientDrop";
  return callPOST(api_url, param);
}
async function getEmployeeDrop(param) {
  let api_url = config.BASE_URL + "hr/api/getEmployeeDrop";
  return callPOST(api_url, param);
}
/* ---------------------------- PLM APP --------------------------------*/

const func = {
  handleResponseError,
  handleError,
  callGET,
  callPOST,
  callPOSTUpload,

  getMenuOnUserRole,
  getConfig,
  getLoginUserData,
  uploadFiles,
  getUploadedFiles,
  generateChartQuery,
  dashboard,
  addEmployee,
  cancelOrDeleteEmp,
  updateEmployee,
  markAttendance,
  getAttendance,
  getAllAttendance,
  updateAttendance,
  addHrDocuments,
  cancelOrDeleteHrDoc,
  updateHrDocuments,
  approveHrDocument,
  addTask,
  generateCustomerQuery,
  updateTask,
  cancelOrDeleteTask,
  getAllTask,
  getTask,
  updateTaskStatus,
  getEmployeeOrg,
  uploadEmployeeImg,
  addExpenses,
  cancelOrDeleteExpense,
  updateExpense,
  addProject,
  cancelOrDeleteProject,
  updateProject,
  getClientDrop,
  getEmployeeDrop
};

export default func;
